import { StickerTypes } from "../../constants/StickerTypes";
import WithPriceDecorator from "../../decorators/WithPriceDecorator";
import Product from "../../entities/product/Product";
import { IDiscounts, IProduct } from "../../entities/product/types";
import SpecificationFactory from "./SpecificationFactory";


export default class ProductFactory {

  private static readonly getImagesByType = (productImages: any, type: string): null | any[] => {
    let images;
    if (Array.isArray(productImages)) {
      images = productImages.find((image: any) => image.imageType === type);
    }

    return typeof images !== 'undefined' ? images : null;
  };

  public static createFromResponse(product: any, discounts?: IDiscounts): IProduct {
    const productEntity = new Product(
      product.id,
      product.phoneId,
      product.model,
      product.desc,
      product.productLine,
      product.manufacturer,
      product.status,
      product.sellCosmos,
      product.sellSubsidy,
      product.sellTelenorHome,
      product.sellWithoutContractObligation,
      product.cosmosSpecial,
      product.productGroup,
      product.groupMaster,
      product.assignedTariffPackage,
      product.tariffPackages,
      product.outlet,
      product.label,
      product.productImages,
      product.productColorsImages,
      product.productCharacteristics,
      product.productPrices,
      product.promoUrl,
      {
        displayPrice: 0,
        displayCreditPrice: 0,
        displayCreditPriceInRate: 0,
        displayCreditOldPriceInRate: 0,
        displayCreditRate: 0,
        displayInstallmentsPriceForTable: []
      },
      SpecificationFactory.createFromProductCharacteristics(product.productCharacteristics),
      this.getImagesByType(product.productImages, StickerTypes.INDEX),
      this.getImagesByType(product.productImages, StickerTypes.DETAILS),
      this.getImagesByType(product.productImages, "specification"),
      product.cosmosModel,
      {
        withInsurance: product.generalFlags ? product.generalFlags.withInsurance : false,
      },
      product.erpCode,
      product.bundles,
      product.cosmosTariffPackages,
      product.subsidyTariffPackages,
      discounts?.greenVoucherDiscount,
      discounts?.ebillDiscount,
      product.showDiscountSticker,
    );

    return (new WithPriceDecorator(productEntity)).getProduct();
  }

}
